// TIE & SUITED TIE BETGRID COMPONENT NAME FOR CRICKETWAR, DRAGONTIGER
export const TIE_SUITEDTIE_COMPONENT = 'TieSuitedTie';
